export default __webpack_public_path__ + "static/media/footer-twitter.4306e4e1.svg";